export default __webpack_public_path__ + "static/media/Rectangle_79.b4b2c5f6.png";